<template>
    <el-main>
        <div class="box-card">
            <MediaDeviceCheck />
            <!-- <BandWidthCheck
                v-on:changeError="handleError('bandwidth', $event)"
            /> -->
            <WebSocketCheck
                v-on:changeError="handleError('websocket', $event)"
            />
            <el-card v-if="content && content.type">
                <status-content
                    :content="content"
                />
            </el-card>
        </div>
    </el-main>
</template>

<script>
import { mapState } from 'vuex';
import MediaDeviceCheck from './MediaDeviceCheck';
// import BandWidthCheck from './BandWidth/BandWidthCheck';
import WebSocketCheck from './WebSocketsCheck';
import StatusContent from './StatusContent.vue';

export default {
    name: 'PreCallCheck',
    components: {
        MediaDeviceCheck,
        // BandWidthCheck,
        WebSocketCheck,
        StatusContent,
    },
    watch: {
        // bandWidthError(){
        //     this.handleContent();
        // },
        webSocketError(){
            this.handleContent();
        },
        audioError(){
            this.handleContent();
        },
        videoError(){
            this.handleContent();
        },
    },
    data() {
        return {
            bandWidthError: undefined,
            webSocketError: undefined,
            content: {},
        };
    },
    methods: {
        handleError(type, event) {
            if (type === 'bandwidth') {
                this.bandWidthError = event;
            } else if(type=== 'websocket'){
                this.webSocketError = event;
            }
        },
        handleContent() {
            if(
                // this.bandWidthError ||
                this.webSocketError ||
                this.audioError ||
                this.videoError
            ){
                this.content = {
                    message: `Please check our system requirements (https://www.berst.io/system-requirements.html) to check any other configuration changes that may be required.
                        A device conflict can also sometimes be resolved by a restart.`,
                    type: 'error',
                };
            } else if (
                // this.bandWidthError===undefined ||
                this.webSocketError===undefined ||
                this.audioError===undefined ||
                this.videoError===undefined
            ){
                this.content={
                    type:"warning",
                    message:"Please start the tests to check you are ready to connect."
                }
            }else {
                this.content = {
                    message:`Everything is working great.
                            You are ready to connect!`,
                    type:'success'
                }
            }
        },
    },
    computed: {
        ...mapState({
            audioError: (state) => state.devices.audioError,
            videoError: (state) => state.devices.videoError,
        }),
    },
};
</script>

<style scoped>
.el-main {
    height: 100%;
    overflow: auto;
}
.box-card {
    width: 480px;
    margin: 0 auto;
}

.box-header {
    display: flex;
    align-items: center;
}
</style>
